import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  parseNumberByPrecision,
  tableBetHistoryStore,
  useTranslation,
  userInfoStore,
} from '@pascal/pascal-core';
import { CARDS_TYPE } from '../../../enums/cardTypes';
import { MARKET_TYPES } from '../../../enums/betTypes';

import '../SelectedHistory.scss';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;
  const t = useTranslation();

  return (
    <div className='tb-game-history-wrapper'>
      <div className='cards-row-wrapper'>
        <div className='history-mini-table-wrapper'>
          <div className='history-mini-table-row'>
            <div className='history-mini-table-item-dealer'>
              <span className='history-mini-table-txt'>{t('DEALER')}</span>
            </div>
          </div>
        </div>
        <div className='tb-game-history-wrapper'>
          <div className='cards-row-wrapper top'>
            <div className='cards-row-combinations-container'>
              <div className='history-cards-wrapper'>
                <div className='history-cards-part'>
                  <div className='history-cards-points-wrapper'>
                    <div className='history-cards-container'>
                      {thirdStepData.dealerCards.map(({ card, index }) => (
                        <div key={index} className={`history-inner-card ${CARDS_TYPE[card]}`} />
                      ))}
                    </div>
                    <div className='history-cards-points-container'>
                      <span className='history-cards-points-txt'>{thirdStepData.dealerPoint}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {thirdStepData.handOfBets.map((item, index) => {
        const cards = item?.mainBetCards || item?.splitBetCards;
        const currentBet = item?.mainBet || item?.splitBet;
        return (
          <div className='cards-row-wrapper' key={`handType:`.concat(index)}>
            <div className='history-mini-table-wrapper'>
              <div className='history-mini-table-row head'>
                <div className='history-mini-table-item'>
                  <span className='history-mini-table-txt'>{t('TYPE')}</span>
                </div>
                <div className='history-mini-table-item'>
                  <span className='history-mini-table-txt'>{t('RESULT')}</span>
                </div>
                <div className='history-mini-table-item'>
                  <span className='history-mini-table-txt'>{t('BET')}</span>
                </div>
                <div className='history-mini-table-item'>
                  <span className='history-mini-table-txt'>{t('WIN')}</span>
                </div>
              </div>
              <div className='history-mini-table-row'>
                <div className='history-mini-table-item'>
                  <span className='history-mini-table-txt'>
                    {item?.splitBetCards ? t('SPLIT_BET') : t('MAIN_BET')}{' '}
                    {item?.mainBet && thirdStepData.doubleBet ? `+ ${t('DOUBLE')}` : ''}
                    {item?.mainBet && thirdStepData.hasSurrender ? `+ ${t('SURRENER')}` : ''}
                  </span>
                </div>
                <div className='history-mini-table-item'>
                  <span className='history-mini-table-txt' />
                </div>
                <div className='history-mini-table-item bet'>
                  <span className='history-mini-table-txt'>
                    {thirdStep.data?.freebetId && 'FREE BET: '}
                    {parseNumberByPrecision(
                      1,
                      thirdStepData.doubleBet
                        ? currentBet.amount + thirdStepData.doubleBet.amount
                        : currentBet.amount,
                      +userInfoStore.precision
                    )}
                  </span>
                </div>
                <div className='history-mini-table-item win'>
                  <span className='history-mini-table-txt'>
                    {parseNumberByPrecision(
                      1,
                      thirdStepData.doubleBet
                        ? currentBet.winAmount + thirdStepData.doubleBet.winAmount
                        : currentBet.winAmount,
                      +userInfoStore.precision
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className='tb-game-history-wrapper'>
              <div className='cards-row-wrapper top'>
                <div className='cards-row-combinations-container'>
                  <div className='history-cards-wrapper'>
                    <div className='history-cards-part'>
                      <div className='history-cards-points-wrapper'>
                        <div className='history-cards-container'>
                          {cards.map(({ card, index: cardIndex }) => (
                            <div
                              key={cardIndex}
                              className={`history-inner-card ${CARDS_TYPE[card]}`}
                            />
                          ))}
                        </div>
                        <div className='history-cards-points-container'>
                          <span className='history-cards-points-txt'>{item.point}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      {thirdStepData.sideBets.map(({ type, amount, winAmount }) => {
        return (
          <div className='limit-payouts-row' key={type}>
            <div className='limit-payouts-column name'>
              {t(MARKET_TYPES.side21plus3 === type ? '21+3' : 'P_P')}
            </div>
            <div className='limit-payouts-column number'>{amount}</div>
            <div className='limit-payouts-column number'>{winAmount}</div>
          </div>
        );
      })}
      {thirdStepData.insurance && (
        <div className='history-total-row insurance'>
          <div className='history-total-item'>
            <div className='history-total-row-txt'>{t('INSURANCE')}</div>
          </div>
          <div className='history-total-item'>
            <div className='history-total-row-txt'>{thirdStepData.insurance.amount}</div>
          </div>
          <div className='history-total-item'>
            <div className='history-total-row-txt'>{thirdStepData.insurance.winAmount}</div>
          </div>
        </div>
      )}
      <div className='history-total-row'>
        <div className='history-total-item'>
          <div className='history-total-row-txt'>{t('TOTAL')}</div>
        </div>
        <div className='history-total-item'>
          <div className='history-total-row-txt'>{thirdStepData?.totalAmount}</div>
        </div>
        <div className='history-total-item'>
          <div className='history-total-row-txt'>{thirdStepData?.totalWinAmount}</div>
        </div>
      </div>
    </div>
  );
});
